import React from "react";
import ContentSection from "./components/content/ContentSection";
import { PricePromiseFormProvider } from "./components/context";
import useForm from "./components/context/useForm";
import QualifyingSection from "./components/qualifying-section/QualifyingSection";
import RequestForm from "./components/request-form/RequestForm";
import styles from "./request.module.scss";
import { useFormDisqualification, useFormProgressHandler, usePageLoad } from "./useAnalyticsHooks";
import displayConditions, { ELEMENTS } from "./utils";

const PricePromiseRequestForm = () => {
  const { state: responses } = useForm();
  const shouldDisplay = displayConditions(responses);

  usePageLoad();
  useFormProgressHandler();
  useFormDisqualification(responses);

  return (
    <div className={styles["grid-container"]}>
      <ContentSection />
      <QualifyingSection />
      {shouldDisplay(ELEMENTS.CUSTOM_FORM) && <RequestForm />}
    </div>
  );
};

export const metadata = {
  title: `Request a John Lewis price promise refund`,
  description: `Found a better price within 7 days? If one of our 25 retailers has a lower price, fill out the form for a refund on the difference.`,
};

const PricePromiseRequest = () => {
  return (
    <PricePromiseFormProvider>
      <PricePromiseRequestForm />
    </PricePromiseFormProvider>
  );
};

PricePromiseRequest.metadata = metadata;

export default PricePromiseRequest;
